import api from './api';

export interface User {
  id: number;
  email: string;
  login: string;
  nome: string;
  cliente_id?: number;
  idmongodb_cliente?: string;
  mongo_roles?: string;
  login_old?: string;
  dataremocao?: string;
}

export interface UserCreate {
  email: string;
  login: string;
  nome: string;
  password: string;
  cliente_id?: number;
  idmongodb_cliente?: string;
  mongo_roles?: string;
  login_old?: string;
}

export interface UserUpdate {
  email?: string;
  login?: string;
  nome?: string;
  password?: string;
  cliente_id?: number;
  idmongodb_cliente?: string;
  mongo_roles?: string;
  login_old?: string;
}

export interface UserFilter {
  email?: string;
  login?: string;
  nome?: string;
  cliente_id?: number;
}

export interface Role {
  usuario_id: number;
  role: string;
}

class UsersService {
  async getUsers(filter: UserFilter = {}, skip: number = 0, limit: number = 10): Promise<User[]> {
    const params = new URLSearchParams();
    
    // Add pagination
    params.append('skip', skip.toString());
    params.append('limit', limit.toString());
    
    // Add filters if provided
    if (filter.email) params.append('email', filter.email);
    if (filter.login) params.append('login', filter.login);
    if (filter.nome) params.append('nome', filter.nome);
    if (filter.cliente_id) params.append('cliente_id', filter.cliente_id.toString());
    
    const response = await api.get(`/usuarios/?${params.toString()}`);
    return response.data;
  }
  
  async getUsersCount(filter: UserFilter = {}): Promise<number> {
    // In a real application, you might have a dedicated endpoint for counting
    // Here I'm just getting all users with the filter and counting them
    const params = new URLSearchParams();
    
    // Add filters if provided
    if (filter.email) params.append('email', filter.email);
    if (filter.login) params.append('login', filter.login);
    if (filter.nome) params.append('nome', filter.nome);
    if (filter.cliente_id) params.append('cliente_id', filter.cliente_id.toString());
    
    const response = await api.get(`/usuarios/count?${params.toString()}`);
    return response.data;
  }
  
  async getUser(id: number): Promise<User> {
    const response = await api.get(`/usuarios/${id}`);
    return response.data;
  }
  
  async createUser(user: UserCreate): Promise<User> {
    const response = await api.post('/usuarios/', user);
    return response.data;
  }
  
  async updateUser(id: number, user: UserUpdate): Promise<User> {
    const response = await api.put(`/usuarios/${id}`, user);
    return response.data;
  }
  
  async deleteUser(id: number): Promise<User> {
    const response = await api.delete(`/usuarios/${id}`);
    return response.data;
  }
  
  async getUserRoles(id: number): Promise<Role[]> {
    const response = await api.get(`/usuarios/${id}/roles`);
    return response.data;
  }
  
  async addUserRole(id: number, role: string): Promise<any> {
    const response = await api.post(`/usuarios/${id}/roles/${role}`);
    return response.data;
  }
  
  async removeUserRole(id: number, role: string): Promise<any> {
    const response = await api.delete(`/usuarios/${id}/roles/${role}`);
    return response.data;
  }
}

export default new UsersService(); 